document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-cart-timer-bar]');
  if (!bar) return;

  const countEl = bar.querySelector('[data-cart-timer-count]');
  const itemLabelEl = bar.querySelector('[data-cart-timer-item-label]');
  const minutesEl = bar.querySelector('[data-cart-timer-minutes]');
  const secondsEl = bar.querySelector('[data-cart-timer-seconds]');
  const offerTextEl = bar.querySelector('[data-cart-timer-offer-text]');
  const timerDisplayEl = bar.querySelector('[data-cart-timer-display]');
  const timerIconEl = bar.querySelector('[data-cart-timer-icon]');
  const totalMinutes = parseInt(bar.dataset.cartTimerMinutes, 10) || 5;

  const STORAGE_KEY = 'cart-timer-end';
  const EXPIRED_KEY = 'cart-timer-expired';
  let timerInterval = null;

  const padZero = (num) => String(num).padStart(2, '0');

  const getRemainingSeconds = () => {
    const endTime = sessionStorage.getItem(STORAGE_KEY);
    if (!endTime) return -1;
    const remaining = Math.round((parseInt(endTime, 10) - Date.now()) / 1000);
    return remaining > 0 ? remaining : 0;
  };

  const recalcMainPadding = () => {
    const mainEl = document.querySelector('main');
    const headerGroup = document.querySelector('.header-group-wrapper');
    if (mainEl && headerGroup) {
      mainEl.style.paddingTop = headerGroup.offsetHeight + 'px';
    }
  };

  const updateTimerDisplay = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    minutesEl.textContent = padZero(mins);
    secondsEl.textContent = padZero(secs);
  };

  const hideTimerElements = () => {
    if (offerTextEl) offerTextEl.style.display = 'none';
    if (timerDisplayEl) timerDisplayEl.style.display = 'none';
    if (timerIconEl) timerIconEl.style.display = 'none';
  };

  const showTimerElements = () => {
    if (offerTextEl) offerTextEl.style.display = '';
    if (timerDisplayEl) timerDisplayEl.style.display = '';
    if (timerIconEl) timerIconEl.style.display = '';
  };

  const hideBar = () => {
    stopTimer();
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.setItem(EXPIRED_KEY, '1');
    hideTimerElements();
    recalcMainPadding();
  };

  const startTimer = () => {
    if (timerInterval) clearInterval(timerInterval);

    let remaining = getRemainingSeconds();

    if (remaining === -1) {
      sessionStorage.setItem(STORAGE_KEY, String(Date.now() + totalMinutes * 60 * 1000));
      remaining = totalMinutes * 60;
    }

    if (remaining <= 0) {
      hideBar();
      return;
    }

    updateTimerDisplay(remaining);

    timerInterval = setInterval(() => {
      const secs = getRemainingSeconds();
      if (secs <= 0) {
        hideBar();
        return;
      }
      updateTimerDisplay(secs);
    }, 1000);
  };

  const stopTimer = () => {
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
  };

  const syncBar = (itemCount) => {
    if (itemCount > 0) {
      countEl.textContent = itemCount;
      if (itemLabelEl) {
        itemLabelEl.textContent = itemCount === 1 ? 'item' : 'items';
      }

      bar.classList.add('is-visible');

      if (sessionStorage.getItem(EXPIRED_KEY)) {
        hideTimerElements();
      } else {
        showTimerElements();
        if (!timerInterval) startTimer();
      }
    } else {
      bar.classList.remove('is-visible');
      stopTimer();
      sessionStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(EXPIRED_KEY);
    }
  };

  const readBadgeCount = () => {
    const badge = document.querySelector('[data-cart-count]');
    if (!badge) return 0;
    return parseInt(badge.textContent, 10) || 0;
  };

  syncBar(readBadgeCount());

  const observer = new MutationObserver(() => {
    syncBar(readBadgeCount());
  });

  document.querySelectorAll('[data-cart-count]').forEach((badge) => {
    observer.observe(badge, { childList: true, characterData: true, subtree: true });
  });

  // Clear checkout_source on page load so it doesn't persist from a previous session
  const root = window.Shopify?.routes?.root || '/';
  fetch(`${root}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: { checkout_source: '' },
    }),
  }).catch(() => {});

  const timerCheckout = bar.querySelector('[data-timer-checkout]');
  if (timerCheckout) {
    timerCheckout.addEventListener('click', (event) => {
      const btn = event.target.closest('button, .gokwik-checkout');
      if (!btn) return;

      fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { checkout_source: 'timer_bar' },
        }),
      }).catch(() => {});
    }, true);
  }

  const bodyObserver = new MutationObserver(() => {
    const badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach((badge) => {
      observer.observe(badge, { childList: true, characterData: true, subtree: true });
    });
  });

  const headerGroup = document.querySelector('.header-group-wrapper');
  if (headerGroup) {
    bodyObserver.observe(headerGroup, { childList: true, subtree: true });
  }
});
